"use client"

import type { KeyboardEvent } from "react"
import { theme } from "antd"
import Paragraph from "@/components/common/Typography/Paragraph"
import SupportIcon from "@/components/icons/SupportIcon"
import { getLocalizedText } from "../utils/getLocalizedText"
import type { FaqDto } from "../types"

type FaqImageCardProps = {
  faq: FaqDto
  locale: string
  image?: string
  description?: string
  onOpen: (faq: FaqDto) => void
  className?: string
}

export default function FaqImageCard({ faq, locale, image, description, onOpen, className }: FaqImageCardProps) {
  const { token } = theme.useToken()
  const question = getLocalizedText(faq.question, locale)

  const handleKeyDown = (event: KeyboardEvent) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault()
      onOpen(faq)
    }
  }

  return (
    <div
      className={`faq-image-card${className ? ` ${className}` : ""}`}
      style={{ background: token.colorBgContainer }}
      role="button"
      tabIndex={0}
      onClick={() => onOpen(faq)}
      onKeyDown={handleKeyDown}
    >
      <div className="faq-image-card__cover" style={{ background: token.colorFillTertiary }}>
        {image ? (
          <img src={image} alt={question} />
        ) : (
          <SupportIcon style={{ fontSize: "2.8rem", color: token.colorTextDisabled }} />
        )}
      </div>
      <div className="faq-image-card__body">
        <Paragraph ellipsis={{ rows: 2, tooltip: question }} className="faq-image-card__title">
          {question}
        </Paragraph>
        <Paragraph type="secondary" ellipsis={{ rows: 2, tooltip: description }} className="faq-image-card__description">
          {description}
        </Paragraph>
      </div>
    </div>
  )
}
